module.exports = __webpack_public_path__ + "3e0bf9c5e51f707a89f51770b41736ad.png";